import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Defensive cleanup: unregister any leftover service worker (e.g. one
// registered by PostHog in the original Emergent-hosted version of the site,
// or by a previous deployment). These can intercept /api/* requests and
// silently break the app for returning visitors. Doing this at startup
// guarantees a clean network stack for every page load.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  }).catch(() => { /* no-op */ });
  // Also drop the HTTP caches the SW may have populated
  if (typeof window !== "undefined" && window.caches) {
    window.caches.keys().then((keys) => {
      keys.forEach((k) => window.caches.delete(k));
    }).catch(() => { /* no-op */ });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
